/** Thrown by a section's save to refuse it: the section stays open and shows the message. */
export class SectionSaveRefused extends Error {}
